<template>
  <div class="wrapper">
    <navbar />
    <div class="content" id="content">
      <h4>Medical Examination Report List</h4>
      <!-- <tabs animation="slide" :only-fade="true">
        <tab-pane label="In Progress" selected>
          <div id="in-progress" v-show="inProgressMerCount > 0">
            <table class="table is-bordered">
              <thead>
              <tr>
                <th>Application No.</th>
                <th>Received</th>
                <th>Customer Name</th>
                <th>Gender</th>
                <th>Mobile No</th>
                <th>Attempts Available</th>
                <th>Last Attempt</th>
                <th>Status</th>
                <th>Start</th>
                <th>Reject</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="m in inProgressMers">
                  <td>{{m.application_no}}</td>
                  <td>{{m.date_of_assign}}</td>
                  <td>{{m.insured_name}}</td>
                  <td>{{m.pi_gender}}</td>
                  <td>{{m.pi_mobile_number}}</td>
                  <td>{{availableCallAttempts(m)}}</td>
                  <td class="med-text"><b>Call status:</b> {{m.call_status}}<br> <b>Remarks:</b> {{m.doctor_remarks}} <br> <span class="small-text">{{m.last_call_at | formatDate }}</span></td>
                  <td>{{m.status}}</td>
                  <td>
                    <a href="javascript:void(0)" class="button" @click="openMerModal(m)" v-if="availableCallAttempts(m) > 0">start</a>
                    <a href="javascript:void(0)" class="button" :disabled="true" v-if="availableCallAttempts(m) === 0" title="No call attempts left">start</a>
                  </td>
                  <td><a href="javascript:void(0)" class="buttton is-danger" @click="openRejectMerModal(m)">Reject</a></td>
                </tr>
              </tbody>
            </table>
            <paginate
              :page-count="inProgressTotalPages"
              :initial-page="0"
              :prev-text="'<'"
              :next-text="'>'"
              :click-handler="nextPageInProgressMers"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-item'"
              :prev-link-class="'prev-link-item'"
              :next-class="'next-item'"
              :next-link-class="'next-link-item'"
              :disabled-class="'disabled'"
            ></paginate>
          </div>
          <div class="no-data is-centered" v-if="inProgressMerCount <= 0"><b>No Inprogress MERS Found!</b></div>
        </tab-pane>
        <tab-pane label="Completed">
          <div id="completed" v-show="completedMerCount > 0">
            <table class="table is-bordered">
              <thead>
              <tr>
                <th>Application No.</th>
                <th>Received</th>
                <th>Customer Name</th>
                <th>Gender</th>
                <th>Mobile No</th>
                <th>Attempts Available</th>
                <th>Last Attempt</th>
                <th>Status</th>
                <th>Completed On</th>
                <th>Edit</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="m in completedMers">
                <td>{{m.application_no}}</td>
                <td>{{m.date_of_assign}}</td>
                <td>{{m.insured_name}}</td>
                <td>{{m.pi_gender}}</td>
                <td>{{m.pi_mobile_number}}</td>
                <td>{{availableCallAttempts(m)}}</td>
                <td class="med-text"><b>Call status:</b> {{m.call_status}}<br> <b>Remarks:</b> {{m.doctor_remarks}} <br> <span class="small-text">{{m.last_call_at | formatDate}}</span></td>
                <td>{{m.status}}</td>
                <td>{{m.completed_at | formatDate}}</td>
                <td>
                  <a href="javascript:void(0)" class="button" @click="openMerModal(m)" v-if="availableCallAttempts(m) > 0">edit</a>
                  <a href="javascript:void(0)" class="button" :disabled="true" v-if="availableCallAttempts(m) === 0" title="No call attempts left">edit</a>
                </td>
              </tr>
              </tbody>
            </table>
            <paginate
              :page-count="completedTotalPages"
              :prev-text="'<'"
              :next-text="'>'"
              :click-handler="nextPageCompletedMers"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-item'"
              :prev-link-class="'prev-link-item'"
              :next-class="'next-item'"
              :next-link-class="'next-link-item'"
            ></paginate>
          </div>
          <div class="no-data is-centered" v-if="completedMerCount <= 0"><b>No Completed MERS Found!</b></div>
        </tab-pane>
        <tab-pane label="Rejected">
          <div id="rejected" v-show="rejectedMerCount > 0">
            <table class="table is-bordered">
              <thead>
              <tr>
                <th>Application No.</th>
                <th>Received</th>
                <th>Customer Name</th>
                <th>Gender</th>
                <th>Mobile No</th>
                <th>Attempts Available</th>
                <th>Last Attempt</th>
                <th>Status</th>
                <th>Rejected On</th>
                <th>Reason</th>
                <th>Restart</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="m in rejectedMers">
                <td>{{m.application_no}}</td>
                <td>{{m.date_of_assign}}</td>
                <td>{{m.insured_name}}</td>
                <td>{{m.pi_gender}}</td>
                <td>{{m.pi_mobile_number}}</td>
                <td>{{availableCallAttempts(m)}}</td>
                <td class="med-text"><b>Call status:</b> {{m.call_status}}<br> <b>Remarks:</b> {{m.doctor_remarks}} <br> <span class="small-text">{{m.last_call_at | formatDate }}</span></td>
                <td>{{m.status}}</td>
                <td>{{m.rejected_at | formatDate }}</td>
                <td><a href="javascript:void(0)" @click="showReason(m)">Reason</a></td>
                <td>
                  <a href="javascript:void(0)" class="button" @click="openMerModal(m)" v-if="availableCallAttempts(m) > 0">Restart</a>
                  <a href="javascript:void(0)" class="button" :disabled="true" v-if="availableCallAttempts(m) === 0" title="No call attempt left">Restart</a>
                </td>
              </tr>
              </tbody>
            </table>
            <paginate
              :page-count="rejectedTotalPages"
              :prev-text="'<'"
              :next-text="'>'"
              :click-handler="nextPageRejectedMers"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-item'"
              :prev-link-class="'prev-link-item'"
              :next-class="'next-item'"
              :next-link-class="'next-link-item'"
            ></paginate>
          </div>
          <div class="no-data is-centered" v-if="rejectedMerCount <= 0"><b>No Rejected MERS Found!</b></div>
        </tab-pane>
      </tabs> -->
    </div>
    <div v-if="openMerForm" :class="[openMerForm ?  'is-active' : '', 'modal']">
      <div class="modal-background"></div>
      <button class="modal-close is-large" aria-label="close" @click="closeMerModal"></button>
      <div class="modal-content">
        <section class="modal-card-body">
          <!-- Content ... -->
          <div class="columns">
            <div class="column is-one-quarter border-right">
              <div class="call-status">
                <h3><b>Call Status</b></h3>
                <p><small>Do call the customer and update the call status</small></p>
              </div>
              <div class="customer-name">
                <div class="columns">
                  <div class="column is-one-quarter"></div>
                  <div class="column is-centered">
                    <h3><b>{{mer.insured_name}}</b></h3>
                    <p>{{mer.pi_mobile_number}}</p>
                  </div>
                </div>
              </div>
              <div class="call-attempt">
                Calls Attempted: {{mer.attempted_calls}}
              </div>
              <div class="after-call-attempt" v-show="afterCallAttempt">

                <p><b>Tell us what happened ?</b></p>
                <div class="call-connected" @click="showCallConnectedResult">
                  <p>Call Connected</p>
                </div>
                <div class="call-not-connected" @click="showCallNotConnectedResult">
                  <p>Call Not Connected</p>
                </div>
              </div>
              <div class="after-call-connected" v-show="afterCallConnected">
                <div class="call-heading">
                  <p><b>
                    <span class="icon left-arrow" @click="backToConnected">
                      <i class="fa fa-home"></i><img src="/static/images/back.png"/>
                    </span> Call Connected:</b></p>
                </div>
                <!--<p class="call-item" @click="merCompleted">MER completed</p>-->
                <p class="call-item" @click="openDoctorRemarksForm('Verification incomplete', 0)">Verification incomplete</p>
                <p class="call-item" @click="openDoctorRemarksForm('Call Customer Later', 0)">Call Customer Later</p>
                <p class="call-item" @click="openDoctorRemarksForm('Call Status Call Disconnected (after picking up call)', 0)">Call Status Call Disconnected (after picking up call)</p>
                <p class="call-item" @click="openDoctorRemarksForm('Customer not Audible', 0)">Customer not Audible</p>
                <p class="call-item" @click="openDoctorRemarksFormFor('Language Missmatch with Customer', 0)">Language Missmatch with Customer</p>
                <p class="call-item" @click="openDoctorRemarksFormFor('Customer not Co-operative', 0)">Customer not Co-operative</p>
                <p class="call-item" @click="openDoctorRemarksForm('Medical Checkup done already', 0)">Medical Checkup done already</p>
                <p class="call-item" @click="openDoctorRemarksFormFor('Wrong Customer on Call', 0)">Wrong Customer on Call</p>
                <p class="call-item" @click="openDoctorRemarksForm('Other Reason(s)', 0)">Other Reason(s)</p>
              </div>
              <div class="after-call-not-connected" v-show="afterCallNotConnected">
                <div class="call-heading">
                  <p><b>
                    <span class="icon left-arrow" @click="backToNotConnected">
                      <i class="fa fa-home"></i><img src="/static/images/back.png"/>
                    </span> Call Not Connected:</b></p>
                </div>
                <p class="call-item" @click="openDoctorRemarksForm('Mobile Switched Off / Out of Coverage', 1)">Mobile Switched Off / Out of Coverage</p>
                <p class="call-item" @click="openDoctorRemarksForm('Number Invalid', 1)">Number Invalid</p>
                <p class="call-item" @click="openDoctorRemarksForm('Call Disconnected(before picking of the call)', 1)">Call Disconnected(before picking of the call)</p>
                <p class="call-item" @click="openDoctorRemarksForm('Network Busy', 1)">Network Busy</p>
                <p class="call-item" @click="openDoctorRemarksForm('Other Reason(s)', 1)">Other Reason(s)</p>
              </div>
              <div class="doctor-remarks" v-show="showDoctorRemarksForm">
                <div class="call-heading">
                  <p><b>
                    <span class="icon left-arrow" @click="backFromRemarksForm">
                      <i class="fa fa-home"></i><img src="/static/images/back.png"/>
                    </span> {{mer.call_status}}</b></p>
                </div>
                <div class="doctor-remarks-form">
                  <p><small>Doctor's Remarks(optional)</small></p>
                  <textarea cols="30" rows="5" v-model="mer.doctor_remarks"></textarea>
                  <div><button class="button is-primary is-pulled-right" @click="saveDoctorRemarks">save</button>
                  </div>
                </div>
              </div>
              <div class="mer-completed" v-show="isMerCompleted">
                <div class="is-centered">
                  <h2><b>MER Completed</b></h2>
                </div>
              </div>
            </div>
            <div class="column modal-right-section">
              <h3><b>MER Test - PNB</b></h3>
              <p><small>Please enter and verify below details when on call with the customer</small></p>
              <div class="vertical-tab-wrapper">
                <div class="init-wizard has-text-centered" v-show="!callConnected">
                  <b>Click on call connected to start MER Questionnaire</b>
                </div>
                <div class="wizard-wrapper" v-show="callConnected">
                  <vue-good-wizard
                  ref="wizard"
                  :steps="steps"
                  :onNext="nextClicked"
                  :onBack="backClicked">
                    <div slot="page1">
                      <div class="inner-wrapper">
                        <form>
                          <div class="columns">
                            <div class="column">
                              <p><small>Proposal No</small></p>
                              <p>{{mer.application_no}}</p>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column">
                              <p><small>Customer Name</small></p>
                              <p>{{mer.insured_name}}</p>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "customer_name" value = "correct" v-model="mer.customer_name_verification" v-validate="'required|in:correct,incorrect'"/>
                                Correct
                              </label>
                              <span class="help is-danger" v-show="errors.has('customer_name')"><small>{{ errors.first('customer_name') }}</small></span>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "customer_name" value = "incorrect" v-model="mer.customer_name_verification"/>
                                Incorrect
                              </label>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column">
                              <p><small>Name of the Nominee</small></p>
                              <p><input type="text" name = "nominee_name" v-model="mer.nominee_name" v-validate="'required|alpha_spaces'"/></p>
                              <span class="help is-danger" v-show="errors.has('nominee_name')"><small>{{ errors.first('nominee_name') }}</small></span>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column">
                              <p><small>Gender</small></p>
                              <p>{{mer.pi_gender}}</p>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "gender"   value = "correct" v-model="mer.gender_verification" v-validate="'required|in:correct,incorrect'"/>
                                Correct
                              </label>
                              <span class="help is-danger" v-show="errors.has('gender')"><small>{{ errors.first('gender') }}</small></span>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "gender"   value = "incorrect" v-model="mer.gender_verification"/>
                                Incorrect
                              </label>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column">
                              <p><small>Date of Birth</small></p>
                              <p>{{mer.dob}}</p>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "dob"   value = "correct" v-model="mer.dob_verification" v-validate="'required|in:correct,incorrect'"/>
                                Correct
                              </label>
                              <span class="help is-danger" v-show="errors.has('dob')"><small>{{ errors.first('dob') }}</small></span>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "dob"   value = "incorrect" v-model="mer.dob_verification"/>
                                Incorrect
                              </label>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column">
                              <p><small>Martial Status</small></p>
                              <p><select v-model="mer.martial_status" name="martial_status" v-validate="'required'">
                                <option value="" disabled>Select an Option</option>
                                <option value="Unmarried">Unmarried</option>
                                <option value="Married">Married</option>
                                <option value="Divorced">Divorced</option>
                              </select></p>
                              <span class="help is-danger" v-show="errors.has('martial_status')"><small>{{ errors.first('martial_status') }}</small></span>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column">
                              <p><small>Occupation</small></p>
                              <p>{{mer.occupation}}</p>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "occupation"  value = "correct" v-model="mer.occupation_verification" v-validate="'required|in:correct,incorrect'"/>
                                Correct
                              </label>
                              <span class="help is-danger" v-show="errors.has('occupation')"><small>{{ errors.first('occupation') }}</small></span>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "occupation"  value = "incorrect" v-model="mer.occupation_verification"/>
                                Incorrect
                              </label>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column">
                              <p><small>Question for Customer</small></p>
                              <p>{{mer.secret_question}}</p>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column">
                              <p><small>Answer</small></p>
                              <p><input type="text" name = "answer" v-model="mer.secret_answer" v-validate="'required'"/> </p>
                              <span class="help is-danger" v-show="errors.has('answer')"><small>{{ errors.first('answer') }}</small></span>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column">
                              <p><small>Customer has undergone medical check for PNB ?</small></p>
                              <!--<p>No</p>-->
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "medical_check"  value = "yes"  v-model="mer.medical_check_verification" v-validate="'required|in:yes,no'"/>
                                Yes
                              </label>
                              <span class="help is-danger" v-show="errors.has('medical_check')"><small>{{ errors.first('medical_check') }}</small></span>
                            </div>
                            <div class="column">
                              <label>
                                <input type="radio" name = "medical_check"  value = "no" v-model="mer.medical_check_verification"/>
                                No
                              </label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div slot="page2">
                      <div class="inner-wrapper">
                        <div class="columns" v-for="(q, i) in merQuestions">
                          <div class="column" v-if="i == 0">
                            <p><span>{{i+1}}. </span> {{q.question}}</p>
                            <div class="columns">
                              <div class="column">
                                <input type="number" name = "height-in-feet" min="0" max="6" v-model="mer.height_in_feet" placeholder="feet" v-validate="'required'" @change="convertToCms">
                                <input type="number" name="height-in-inches" min="0" max="12" v-model="mer.height_in_inches" placeholder="inches" v-validate="'required'" @change="convertToCms"/>
                                <span class="help is-danger" v-show="errors.has('height-in-feet') && errors.has('height-in-cms')"><small>{{ errors.first('height-in-feet') }}</small></span>
                                <span class="help is-danger" v-show="errors.has('height-in-inches') && errors.has('height-in-cms')"><small>{{ errors.first('height-in-inches') }}</small></span>
                              </div>
                              <div class="column">
                                <b>( or )</b>
                                <input type="number" name="height-in-cms" min="1" max="215" v-model="mer.height_in_cms" placeholder="in centemetres" v-validate="'required'" @change="convertToFeet"> Cms
                                <span class="help is-danger" v-show="errors.has('height-in-cms') && errors.has('height-in-feet')"><small>{{ errors.first('height-in-cms') }}</small></span>
                              </div>
                              <div class="column">
                                <input type="number" name="weight" min="1" max="100" v-model="mer.weight" placeholder="weight" v-validate="'required'"> Kgs
                                <span class="help is-danger" v-show="errors.has('weight')"><small>{{ errors.first('weight') }}</small></span>
                              </div>
                            </div>
                          </div>
                          <div class="column" v-if="i > 0">
                            <div class="mer-question">
                              <p><span>{{i+1}}. </span> {{q.question}}</p>
                            </div>
                            <div v-show="q.alt_question !== null && q.alt_question !== undefined" class="alt-question">
                              <p><b>(or)</b></p>
                              <p>{{q.alt_question}}</p>
                            </div>
                            <div class="columns  mb-0">
                              <div class="is-one-quarter column">
                                <label>
                                  <input type="radio" :name="'q' + (i + 1)" value="yes" v-model = "answers[i]" v-validate="'required|in:yes,no'"/> Yes
                                </label>
                                <span class="help is-danger" v-show="errors.has('q' + (i + 1))"><small>{{ errors.first('q' + (i + 1)) }}</small></span>
                              </div>
                              <div class="column">
                                <label>
                                  <input type="radio" :name="'q' + (i +1)" value="no" v-model = "answers[i]"/> No
                                </label>
                              </div>
                            </div>
                            <div class="remarks-wrapper" v-show="answers[i] == 'yes' ">
                              <textarea v-model="remarks[i]" :name = "'remarks' + (i + 1)" rows="3" cols="50" placeholder="Remarks" v-validate="answers[i] == 'yes' ? 'required' : ''"></textarea>
                              <span class="help is-danger" v-show="errors.has('remarks' + (i + 1))"><small>{{ errors.first('remarks' + (i + 1)) }}</small></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="page3">
                      <div class="inner-wrapper">
                        <div class="declaration-wrapper">
                          <p><b>Met Life Doctor :</b></p>
                          <p>Sir, I would like to take you through the Declaration which is part of this call.</p>
                          <div class="declaration-content">
                            <p><b>Declaration: </b></p>
                            <p>
                              You Mr/Ms <span>{{mer.insured_name}}</span>, declare that, you have fully understood the questions asked to you as per this call and have furnished complete, true and accurate information after fully understanding the same.
                            </p>
                          </div>
                          <div class="declaration-content">
                            <p><b>MetLife Doctor :</b></p>
                            <p>Sir, are you in agreement with the declaration that I have read out to you ?
                            </p>
                            <p>We thank you for having taken the time to confirm the details. We will process your proposal based on the information provided.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="page4">
                      <div class="inner-wrapper">
                        <div class="columns">
                          <div class="column">
                            <p><small>Proposal No.</small></p>
                            <p>{{mer.application_no}}</p>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <p><small>Name of the proposed Insured</small></p>
                            <p>{{mer.insured_name}}</p>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <p><small>Doctors Feedback and Findings</small></p>
                            <textarea v-model="mer.feedback" cols="70" rows="5" name = "feedback" v-validate="'required'"></textarea>
                            <span class="help is-danger" v-show="errors.has('feedback')"><small>{{ errors.first('feedback') }}</small></span>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="declaration-content">
                              <p>
                                I hereby declare that I have conducted Tele MER of proposed insured, mentioned herein, after due
                                verification of his / her identity and the replies given by me above are based on the said Tele MER.
                                I further affirm that nothing has been misrepresented or concealed by me. I understand that findings
                                of the Tele Medical Examination are significant since the findings herein are relevant for assignment
                                of risk by <b>PNB MetLife India Insurance Company Ltd.</b> and shall form the part of the contract between
                                the life examine and the <b>PNB MetLife India India Insurance Company Ltd.</b>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <p><small>Registration No.</small></p>
                            <p>{{doctorProfile.registration_number}}</p>
                          </div>
                          <div class="column">
                            <p><small>Signature</small></p>
                            <p><img :src="doctorProfile.signature"></p>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <p><small>Date</small></p>
                            <p>{{new Date() | formatDate}}</p>
                          </div>
                          <div class="column">
                            <p><small>Name of the Examiner</small></p>
                            <p>{{this.doctorProfile.name}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </vue-good-wizard>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div :class="[openRejectMerForm ?  'is-active' : '', 'modal']">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Reject MER</p>
          <button class="delete" aria-label="close" @click="closeRejectMerModal"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <p><small>Proposal No.</small></p>
              <p>{{rejectingMer.application_no}}</p>
            </div>
            <div class="column">
              <p><small>Attempts Available</small></p>
              <p>{{availableCallAttempts(rejectingMer)}}</p>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p><small>Reason for rejection</small></p>
              <textarea v-model="rejectingMer.reason_for_reject" cols="70" rows="5"></textarea>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary is-pulled-right" @click="rejectMer">Reject</button>
        </footer>
      </div>
    </div>
    <div :class="[showReasonModal ?  'is-active' : '', 'modal']">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Reason to Reject</p>
          <button class="delete" aria-label="close" @click="closeReason"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <p><small>Proposal No.</small></p>
              <p>{{rejectedMer.application_no}}</p>
            </div>
            <div class="column">
              <p><small>Call Status</small></p>
              <p>{{rejectedMer.call_status}}</p>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <p><small>Reason For Reject</small></p>
              <p>{{rejectedMer.reason_for_reject || '-'}}</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Navbar from '@/components/Navbar'
// import { Tabs, TabPane } from 'vue-bulma-tabs'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
import VeeValidate from 'vee-validate'
import VueGoodWizard from 'vue-good-wizard'
Vue.use(VueGoodWizard)
Vue.use(VeeValidate)

if (window.location.host === 'consultations.ekincare.com' || window.location.host === 'doctorstaging.ekincare.com') {
  axios.defaults.baseURL = 'https://bluebox.ekincare.com/api'
  axios.defaults.headers.common['Authorization'] = 'Token token=-J199Y_I1K29TOeVkvLJUQ'
} else {
  axios.defaults.baseURL = 'http://localhost:5000/api'
  axios.defaults.headers.common['Authorization'] = 'Token token=AZEo0h-6GFFVNZRLI16GXQ'
}

import VTab from 'v-tab'
import 'v-tab/dist/v-tab.css'

Vue.use(VTab)

export default {
  components: {
    Navbar
    // Tabs,
    // TabPane
  },

  data () {
    return {
      feets: null,
      inches: null,
      centemetres: null,
      radioAnswers: [],
      answersResponse: [],
      answers: [],
      questionIds: [],
      remarks: [],
      doctorFeedback: null,
      generalTab: true,
      questionsTab: false,
      declarationTab: false,
      feedbackTab: false,
      openMerForm: false,
      openRejectMerForm: false,
      showReasonModal: false,
      mer: {},
      rejectingMer: {},
      rejectedMer: {},
      inProgressMers: [],
      completedMers: [],
      rejectedMers: [],
      merQuestions: [],
      afterCallAttempt: true,
      afterCallConnected: false,
      afterCallNotConnected: false,
      showDoctorRemarksForm: false,
      callConnectedOptions: null,
      isMerCompleted: false,
      inProgressTotalPages: 0,
      completedTotalPages: 0,
      rejectedTotalPages: 0,
      doctorProfile: {},
      callConnected: false,
      steps: [
        {
          label: 'General Questions',
          slot: 'page1'
        },
        {
          label: 'Questionnaire',
          slot: 'page2'
        },
        {
          label: 'Declaration',
          slot: 'page3'
        },
        {
          label: 'Feedbck',
          slot: 'page4'
        }
      ]
    }
  },
  methods: {
    openMerModal: function (mer) {
      this.mer = mer
      this.remarks = []
      this.fetchMerAnswers()
      this.fetchMerQuestions()
      this.afterCallConnected = false
      this.afterCallNotConnected = false
      this.showDoctorRemarksForm = false
      this.isMerCompleted = false
    },

    closeMerModal: function () {
      this.openMerForm = false
      this.afterCallAttempt = true
      this.mer = {}
      this.answers = []
      this.answersResponse = []
      this.callConnected = false
    },

    openRejectMerModal: function (mer) {
      this.openRejectMerForm = true
      this.rejectingMer = mer
    },

    closeRejectMerModal: function () {
      this.openRejectMerForm = false
      this.rejectingMer = {}
    },

    showReason: function (mer) {
      this.showReasonModal = true
      this.rejectedMer = mer
    },

    closeReason: function () {
      this.showReasonModal = false
      this.rejectedMer = {}
    },

    openDoctorRemarksForm: function (s, i) {
      this.showDoctorRemarksForm = true
      this.callConnectedOptions = i
      this.mer.status = 'in_progress'
      if (i === 0) {
        this.afterCallConnected = false
        this.mer.call_status = 'Connected: ' + s
      } else {
        this.afterCallNotConnected = false
        this.mer.call_status = 'Not Connected: ' + s
      }
    },

    openDoctorRemarksFormFor: function (s, i) {
      const _this = this
      this.openDoctorRemarksForm(s, i)
      this.mer.reason_for_reject = s
      var data = {
        mer_application: {
          call_status: this.mer.call_status,
          reason_for_reject: this.mer.reason_for_reject
        }
      }
      axios.patch('/mer_applications/' + this.mer.id + '/reject', data).then(function (response) {
        _this.$toast.open({
          message: _this.call_status + ', hence rejected',
          type: 'is-danger',
          position: 'is-bottom'
        })
        _this.fetchMers('in_progress', _this.page)
        _this.fetchMers('rejected', 1)
        _this.closeMerModal()
      }).catch(function (error) {
        console.log(error)
        _this.$toast.open({
          message: 'Something went wrong',
          type: 'is-danger',
          position: 'is-bottom'
        })
      })
    },

    backFromRemarksForm: function () {
      if (this.callConnectedOptions === 0) {
        this.showDoctorRemarksForm = false
        this.afterCallConnected = true
      } else {
        this.showDoctorRemarksForm = false
        this.afterCallNotConnected = true
      }
    },

    saveDoctorRemarks: function () {
      var _this = this
      var callStatus = this.mer.call_status
      this.showDoctorRemarksForm = false
      this.afterCallAttempt = true

      var remarksData = {
        mer_application: {
          call_status: callStatus,
          doctor_remarks: this.mer.doctor_remarks
        }
      }
      axios.patch('/mer_applications/' + this.mer.id + '/doctor-remarks', remarksData).then(function (response) {
        _this.fetchMers('in_progress', _this.page)
        _this.fetchMers('rejected', 1)
        _this.fetchMers('completed', 1)
        _this.closeMerModal()
        _this.$toast.open({
          message: 'Remarks saved successfully!',
          type: 'is-success',
          position: 'is-bottom'
        })
//        console.log(response.data)
      }).catch(function (error) {
        _this.$toast.open({
          message: 'Something went wrong while saving remaks',
          type: 'is-danger',
          position: 'is-bottom'
        })
        console.log(error)
      })
    },

    submitMerForm: function () {
      var _this = this
      var answersArr = []
      var merAnswersData = {}
      this.merQuestions.forEach(function (question, index) {
        var merAnwerData = {}
        merAnwerData['mer_question_id'] = question.id
        merAnwerData['answer'] = _this.answers[index]
        merAnwerData['remarks'] = _this.remarks[index]
        answersArr.push(merAnwerData)
      })
      merAnswersData['mer_answers'] = answersArr
      axios.post('/mer_applications/' + this.mer.id + '/mer_answers/create', merAnswersData).then(function (response) {

      }).catch(function (error) {
        _this.$toast.open({
          message: 'Something went wrong while submitting MER',
          type: 'is-danger',
          position: 'is-bottom'
        })
        console.log(error.data, 'error')
      })

      var generalQuestionsData = {
        mer_application: {
          height_in_feet: this.mer.height_in_feet,
          height_in_inches: this.mer.height_in_inches,
          height_in_cms: this.mer.height_in_cms,
          weight: this.mer.weight,
          submitted: 'true'
        }
      }
      axios.patch('/mer_applications/' + _this.mer.id, generalQuestionsData).then(function (response) {
//        console.log(response.data.data, 'mer submitted successfully!')
        _this.mer.submitted = true
      }).catch(function (error) {
        console.log(error.data, 'genralquestions err')
      })
    },

    updateMerForm: function () {
      var _this = this
      var answersArr = []
      var merAnswersData = {}
      this.answersResponse.forEach(function (answer, index) {
        var merAnwerData = {}
        merAnwerData['id'] = answer.id
        merAnwerData['mer_question_id'] = answer.mer_question_id
        merAnwerData['answer'] = _this.answers[index]
        merAnwerData['remarks'] = _this.remarks[index]
        answersArr.push(merAnwerData)
      })
      merAnswersData['mer_answers'] = answersArr
//      console.log(merAnswersData, 'ansData')
      axios.patch('/mer_applications/' + this.mer.id + '/update_mer_answers', merAnswersData).then(function (response) {
      }).catch(function (error) {
        _this.$toast.open({
          message: 'Something went wrong while updating MER',
          type: 'is-danger',
          position: 'is-bottom'
        })
        console.log(error.data, 'error')
      })

      var generalQuestionsData = {
        mer_application: {
          height_in_feet: this.mer.height_in_feet,
          height_in_inches: this.mer.height_in_inches,
          height_in_cms: this.mer.height_in_cms,
          weight: this.mer.weight,
          submitted: 'true'
        }
      }
      axios.patch('/mer_applications/' + _this.mer.id, generalQuestionsData).then(function (response) {
//        console.log(response.data.data, 'mer updated successfully!')
      }).catch(function (error) {
        console.log(error.data, 'mer update err')
      })
    },

    submitFeedback: function () {
      const _this = this
      var generalQuestionsData = {
        mer_application: {
          feedback: this.mer.feedback,
          call_status: this.mer.call_status
        }
      }
      axios.patch('/mer_applications/' + _this.mer.id + '/feedback', generalQuestionsData).then(function (response) {
//        console.log(response.data.data, 'mer updated successfully!')
        _this.$toast.open({
          message: 'MER completed successfully!',
          type: 'is-success',
          position: 'is-bottom'
        })
        _this.fetchMers('in_progress', _this.page)
        _this.fetchMers('completed', 1)
        _this.fetchMers('rejected', 1)
        _this.closeMerModal()
      }).catch(function (error) {
        console.log(error.data, 'mer update err')
      })
    },

    fetchMerAnswers: function () {
      var _this = this
      axios.get('/mer_applications/' + this.mer.id + '/mer_answers').then(function (response) {
//        console.log(response.data.data, 'answers')
        response.data.data.forEach(function (answer, index) {
          _this.answersResponse[index] = answer
          _this.answers[index] = answer.answer
          _this.remarks[index] = answer.remarks
        })
        _this.openMerForm = true
      }).catch(function (error) {
        console.log(error.data)
      })
    },

    rejectMer: function () {
      var _this = this
      var rejectingmerData = {
        mer_application: {
          reason_for_reject: this.rejectingMer.reason_for_reject,
          call_status: this.rejectingMer.call_status
        }
      }
      axios.patch('/mer_applications/' + this.rejectingMer.id + '/reject', rejectingmerData).then(function (response) {
//        console.log('mer rejected successfully!')
        _this.closeRejectMerModal()
        _this.fetchMers('in_progress', _this.page)
        _this.fetchMers('rejected', 1)
        _this.$toast.open({
          message: 'MER rejected successfully!',
          type: 'is-success',
          position: 'is-bottom'
        })
      }).catch(function (error) {
        console.log(error, 'mer reject error')
      })
    },

    verificationIncorrect: function () {
      const _this = this
      var verificationIncorrectData = {
        mer_application: {
          call_status: this.mer.call_status,
          reason_for_reject: 'verification incorrect'
        }
      }
      axios.patch('/mer_applications/' + this.mer.id + '/reject', verificationIncorrectData).then(function (response) {
        _this.$toast.open({
          message: 'Verification Incorrect',
          type: 'is-danger',
          position: 'is-bottom'
        })
        _this.fetchMers('in_progress', _this.page)
        _this.fetchMers('rejected', 1)
        _this.closeMerModal()
      }).catch(function (error) {
        console.log(error)
        _this.$toast.open({
          message: 'Something went wrong',
          type: 'is-danger',
          position: 'is-bottom'
        })
      })
    },

    checkupAlreadyDone: function () {
      const _this = this
      var checkupAlreadyDoneData = {
        mer_application: {
          call_status: this.mer.call_status,
          reason_for_reject: 'Medical checkup already done'
        }
      }
      axios.patch('/mer_applications/' + this.mer.id + '/reject', checkupAlreadyDoneData).then(function (response) {
        _this.$toast.open({
          message: 'Medical checkup already done',
          type: 'is-danger',
          position: 'is-bottom'
        })
        _this.fetchMers('in_progress', _this.page)
        _this.fetchMers('rejected', 1)
        _this.closeMerModal()
      }).catch(function (error) {
        console.log(error)
        _this.$toast.open({
          message: 'Something went wrong',
          type: 'is-danger',
          position: 'is-bottom'
        })
      })
    },

    showCallConnectedResult: function () {
      this.afterCallAttempt = false
      this.afterCallConnected = true
      this.callConnected = true
    },

    showCallNotConnectedResult: function () {
      this.afterCallAttempt = false
      this.afterCallNotConnected = true
    },

    backToConnected: function () {
      this.afterCallAttempt = true
      this.afterCallConnected = false
    },

    backToNotConnected: function () {
      this.afterCallAttempt = true
      this.afterCallNotConnected = false
    },

    nextPageInProgressMers: function (pageNum) {
      this.page = pageNum
      this.fetchMers('in_progress', pageNum)
    },

    nextPageCompletedMers: function (pageNum) {
      this.fetchMers('completed', pageNum)
    },

    nextPageRejectedMers: function (pageNum) {
      this.fetchMers('rejected', pageNum)
    },

    fetchMers: function (status, page) {
      var _this = this
      axios.get('/mer_applications?status=' + status + '&page=' + page).then(function (response) {
        if (status === 'in_progress') {
          _this.inProgressMers = response.data.data
          _this.inProgressTotalPages = response.data.total_pages
        } else if (status === 'completed') {
          _this.completedMers = response.data.data
          _this.completedTotalPages = response.data.total_pages
        } else if (status === 'rejected') {
          _this.rejectedMers = response.data.data
          _this.rejectedTotalPages = response.data.total_pages
        }
      }).catch(function (error) {
        console.log(error.response)
      })
    },

    fetchMerQuestions: function () {
      const _this = this
      axios.get('/mer_questions?gender=' + _this.mer.pi_gender).then(function (response) {
        _this.merQuestions = response.data.data
//        console.log(_this.merQuestions, 'merquestions')
      }).catch(function (error) {
        console.log(error.response)
      })
    },

    availableCallAttempts: function (mer) {
      var callCount = (mer.total_call_attempts - mer.attempted_calls)
      return callCount <= 0 ? 0 : callCount
    },

    convertToCms: function () {
      var feet = this.mer.height_in_feet || 0
      var inches = this.mer.height_in_inches || 0
      var cms = parseInt((feet * 30.48) + (inches * 2.54))
      this.mer.height_in_cms = cms
    },

    convertToFeet: function () {
      var heightInCms = this.mer.height_in_cms || 0
      var heightInFt = heightInCms * 0.0328
      var ftInteger = parseInt(heightInFt)
      var heightInInches = parseInt((heightInFt - ftInteger) * 12)
      this.mer.height_in_feet = ftInteger
      this.mer.height_in_inches = heightInInches
    },

    nextClicked (currentPage) {
      const _this = this
//      console.log(currentPage, 'current page')
      if (currentPage === 0) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            var medicalCheckVerification = _this.mer.medical_check_verification
            var customerNameVerfication = _this.mer.customer_name_verification
            var genderVerification = _this.mer.gender_verification
            var dobVerification = _this.mer.dob_verification
            var occupationVerification = _this.mer.occupation_verification
            if (customerNameVerfication === 'incorrect' || genderVerification === 'incorrect' || dobVerification === 'incorrect' || occupationVerification === 'incorrect') {
              _this.verificationIncorrect()
            } else if (medicalCheckVerification === 'yes') {
              _this.checkupAlreadyDone()
            } else {
              var generalQuestionsData = {
                mer_application: {
                  nominee_name: this.mer.nominee_name,
                  customer_name_verification: this.mer.customer_name_verification,
                  gender_verification: this.mer.gender_verification,
                  dob_verification: this.mer.dob_verification,
                  martial_status: this.mer.martial_status,
                  occupation_verification: this.mer.occupation_verification,
                  secret_answer: this.mer.secret_answer,
                  medical_check_verification: this.mer.medical_check_verification,
                  doctor: {name: this.doctorProfile.name, registration_no: this.doctorProfile.registration_number, signature: this.doctorProfile.signature}
                }
              }
              axios.patch('/mer_applications/' + _this.mer.id, generalQuestionsData).then(function (response) {
//                console.log(response.data.data, 'mer submitted successfully!')
                _this.$refs.wizard.goNext(true)
              }).catch(function (error) {
                console.log(error.data, 'genralquestions err')
                _this.$toast.open({
                  message: 'Something went wrong',
                  type: 'is-danger',
                  position: 'is-bottom'
                })
              })
            }
          }
        })
        return false
      } else if (currentPage === 1) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (!this.mer.submitted) {
              _this.submitMerForm()
              _this.$refs.wizard.goNext(true)
            } else {
              _this.updateMerForm()
              _this.$refs.wizard.goNext(true)
            }
          }
        })
      } else if (currentPage === 2) {
        return true
      } else if (currentPage === 3) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            _this.submitFeedback()
          }
        })
      }
      return false
    },

    backClicked (currentPage) {
//      console.log('back clicked', currentPage)
      return true
    }
  },

  created: function () {
    var _this = this
    this.page = 1
    this.fetchMers('in_progress', 1)
    this.fetchMers('completed', 1)
    this.fetchMers('rejected', 1)
    this.$http.get(window.API_URL + 'doctors/profile').then(function (response) {
      _this.doctorProfile = response.body.doctor
    }).catch(function (error) {
      console.log(error)
    })
  },

  computed: {
    inProgressMerCount: function () {
      return this.inProgressMers.length
    },

    completedMerCount: function () {
      return this.completedMers.length
    },

    rejectedMerCount: function () {
      return this.rejectedMers.length
    }

  }

}
</script>
<style scoped>
  li.is-active a {
    border-bottom: 3px solid #00B0FF !important;
  }

  .modal-content {
    width: 90%;
    font-size: 14px;
  }

  .content{

  }

  .border-right {
    border-right: 1px solid #c0c0c0
  }

  .v-tab {

  }

  .v-tab.v-tab-vertical .v-tab-tabs {
    min-width: 150px
  }

  .v-tab .v-tab-tabs .v-tab-tab{
    background-color: #fff;
    color: #777;
    width: 150px
  }

  .v-tab .v-tab-tabs .v-tab-tab:hover{
    cursor: pointer;
  }

  .v-tab .v-tab-tabs .v-tab-tab.active{
    border-left: 3px solid #5295cf;
    color: #fff;
  }

  .v-tab .v-tab-content {
    /*border-left: 1px solid #f1f1f1;*/
    padding: 0px 20px;
    min-height: 500px
  }

  .vertical-tab-wrapper{
    margin-top: 20px
  }

  .form-footer{
    border-top: 1px solid #f1f1f1;
    padding: 20px;
    margin-top: 20px
  }

  .declaration-wrapper {
    min-height: 500px;
  }

  .declaration-content {
    margin-top: 20px
  }
  .mb-0{
    margin-bottom: 0px !important;
  }

  .inner-wrapper {
    /*height: 600px;*/
    /*overflow-y: scroll;*/
    /*overflow-x: hidden;*/
  }
  .call-status {
    padding-bottom: 20px;
    border-bottom: 1px solid #f1f1f1;
  }
  .customer-name {
    padding: 20px 0;
    border-bottom: 1px solid #f1f1f1
  }

  .after-call-attempt {
    padding: 20px;
    margin-top: 20px;
    border-top: 1px solid #f1f1f1
  }

  .call-connected, .call-not-connected {
    padding: 10px;
    border: 3px solid #f4f4f4;
    margin: 10px 0;
    cursor: pointer
  }

  .call-attempt {
    height: 30px;
    background-color: #f1f1f1;
    padding: 5px 10px;
    margin-top: 20px;
  }

  .call-item {
    padding: 5px;
    border: 2px solid #f4f4f4;
    margin: 5px 0;
    cursor: pointer
  }

  .call-heading {
    border-bottom: 1px solid #f1f1f1;
    padding: 10px 0;
    margin-bottom: 20px
  }
  .left-arrow {
    cursor: pointer
  }
  .mer-completed {
    background-color: #006400;
    padding: 40px 20px 20px 50px;
    height: 100px
  }

  .mer-completed h2 {
    color: #fff
  }
  ul.pagination {
    display: inline-block;
    padding-left: 0;
    margin: 0 0 20px 0;
    border-radius: 4px;
    list-style-type: none;
    float: right;
  }

  .page-item {
    display: inline;
  }


  .page-item {

  }
  .page-link-item {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .prev-item {
    float: left;
  }
  .prev-link-item {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .next-item {
    float: right;
    margin-top: 0px !important;
  }
  .next-link-item {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .active a {
    background-color: #337ab7;
    color: #fff
  }
  .modal-right-section {
    min-height: 600px;
  }
  .init-wizard {
    margin-top: 25%
  }
  .small-text {
    font-size: 11px
  }
  .med-text {
    font-size: 14px
  }
</style>



// WEBPACK FOOTER //
// src/components/Mer/Mer.vue